import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL;

function buildQuery(params = {}) {
  const filtered = Object.entries(params).filter(
    ([, value]) => value !== undefined && value !== null && value !== ""
  );
  if (!filtered.length) {
    return "";
  }
  return `?${new URLSearchParams(Object.fromEntries(filtered)).toString()}`;
}

export default {
  getAll(params = {}) {
    return axios.get(`${API_URL}/cotizaciones${buildQuery(params)}`, {
      headers: authHeader(),
    });
  },
  get(id) {
    return axios.get(`${API_URL}/cotizaciones/${id}`, {
      headers: authHeader(),
    });
  },
  convert(id, clientId = null, conversionType = 'venta', tipoDocId = '00FE') {
    return axios.post(`${API_URL}/cotizaciones/${id}/convert`, {
      client_id: clientId,
      conversion_type: conversionType,
      tipo_doc_id: tipoDocId,
    }, {
      headers: authHeader(),
    });
  },
  remove(id) {
    return axios.delete(`${API_URL}/cotizaciones/${id}`, {
      headers: authHeader(),
    });
  },
};
